import { getCustomFields } from '@atlassian/jira-portfolio-3-portfolio/src/app-simple-plans/query/custom-fields';
import { getVisualisationSorting } from '@atlassian/jira-portfolio-3-portfolio/src/app-simple-plans/query/visualisations';
import type { State } from '@atlassian/jira-portfolio-3-portfolio/src/app-simple-plans/state/types';

// eslint-disable-next-line jira/import/no-anonymous-default-export
export default (state: State) => ({
	sorting: getVisualisationSorting(state),
	customFields: getCustomFields(state),
});
